import { useState, useEffect } from 'react';
import * as mqtt from 'react-paho-mqtt';
import comm_data from '../comm_data';

const Mos = (props) => {
    const [events, setEvents] = useState(null);
    const [moteck, setMoteck] = useState(null);
    const [moteckAL, setMoteckAL] = useState(null);
    const [moteckAlertReply, setMoteckAlertReply] = useState(false);
    const [fsenLeft, setFsenLeft] = useState(null);
    const [fsenRight, setFsenRight] = useState(null);
    const [fsenDown, setFsenDown] = useState(null);
    const [exportStart, setExportStart] = useState(false);
    const [diaper, setDiaper] = useState(null);
    const [rr, setRR] = useState(null);
    const [CFHeartBeat, setCFHeartBeat] = useState(null);
    const [CFBreath, setCFBreath] = useState(null);
    const [door, setDoor] = useState(null);
    const [humid, setHumid] = useState(null);
    const [vibration, setVibration] = useState(null);
    const [temperature, setTemperature] = useState(null);
    const [pir, setPir] = useState(null);
    const [medicalButton, setMedicalButton] = useState(null);
    const [epDevice, setEpDevice] = useState(null);
    const [connectionCheck, setConnectionCheck] = useState(0);
    const [startUpdateService, setStartUpdateService] = useState(false);
    const [line_notify_bed_map, setLine_notify_bed_map] = useState(null);

    const [rssi, setRssi] = useState(null);
    const [volume, setVolume] = useState(null);

    const _topic = [
        "mwg/events", // 床 - 即時告警:
        "mwg/Moteck", // 床 - 即時狀態/角度 (auto & lock請改用mwg/Moteck_auto_lock來判斷)
        "mwg/Moteck_auto_lock", // 床 - 即時狀態/只針對不同床的auto和lock
        "FSensor/Left", // 床 - 左半部即時動態
        "FSensor/Right", // 床 - 右半部即時動態
        "FSensor/Down", // 床 - 下半部即時動態

        'alert_reply', // aidc moteck TR usb 脫落、插拔問題、沒壓B
        "mwg_mqtt_tr/AIDC_raw_data_Left",
        "mwg_mqtt_tr/AIDC_raw_data_Right",
        "mwg_mqtt_tr/AIDC_raw_data_Down",

        "export/daily_report/service_start",  // 啟動每日報表會出功能

        "RR", // 床 - 給 前端呼吸值
        "mwg/breath",
        "mwg_mqtt_tr/CF_RR", // 僑福 - 給 心跳值

        // 'mwg/breath', // 床 - 給 後端呼吸值

        "volume", // 床 - 音量大小
        "volume_min", // 床 - 每分鐘的即時音量
        "ap_rssi", // 床 - 即時 rssi

        "mwg_mqtt_tr/AIDC_device_data_in", // 後端(透過moteck傳過來)/床 - 即時狀態(角度)
        // "mwg_mqtt_tr/AIDC_device_data_out/BBBBBBBBBBBB", // 練習用的
        "qingsheng_diaper", // 慶生模擬器
        "diaper_resolved", // 慶生模擬器

        "scientech/door", // 宣佑-門磁:
        "scientech/vibration", // 宣佑-WC震動:
        "scientech/humid", // 宣佑-溼度:
        "scientech/temp", // 宣佑-溫度:
        "scientech/pir", // 宣佑-陽台:
        "scientech/pir_reactive", // 宣佑-陽台:
        "scientech/medicalbutton", // 宣佑-陽台:
        "epmed", // 奕寶 - 全部
        "verify_client_connection", // 後端確認前端連線
        "upgrade_gv_system/adminReverseService",
        "upgrade_gv_system/adminStopService",
        'line_notify/get_bed_map'
    ];

    const _options = {};
    const [client, setClient] = useState(null);
    const [sub, setSub] = useState(false); // 確定是已訂閱 Boolean
    const mos_port = Number(61614)

    // MQTT串接
    const _init = () => {
        const dateTime = Date.now();
        const timestamp = Math.floor(dateTime / 1000);
        const clientid = "clientid-" + timestamp.toString() + Math.random();
        setClient(mqtt.connect(comm_data.API_HOST_MQTT, mos_port, clientid, _onConnectionLost, _onMessageArrived, sendPayload));
    }

    // ✏*: called when sending payload
    const sendPayload = (topic, msg) => {
        // ⟁ 1.2.1 測試 TOPIC "TEST" 成功會出現 "Hello World"
        if (client !== null && client.isConnected()) {
            const payload = mqtt.parsePayload(topic, msg); // topic, payload
            client.send(payload);
        }
    }

    // ✏*: called when client lost connection
    const _onConnectionLost = responseObject => {
        if (responseObject.errorCode !== 0) { }
    }
    // ✏*: called when messages arrived
    const _onMessageArrived = (mqttmessage) => {
        let mwg_msg, _parseMsg, mac, value;
        switch (mqttmessage.topic) {
            // NOTE: MWG topic
            case "mwg/events": // 床 - 即時告警(角度):
                mwg_msg = JSON.parse(mqttmessage.payloadString);
                if (parseInt(mwg_msg.events.bedState) === 208) { return }
                setEvents({
                    bed_id: parseInt(mwg_msg.events.bedId),
                    alert_level: parseInt(mwg_msg.events.bedStateAlertLevel),
                    bed_state: parseInt(mwg_msg.events.bedState),
                    timestamp: mwg_msg.timestamp
                    // timestamp: mwg_msg.timestamp.slice((mwg_msg.timestamp.indexOf("T") + 1), mwg_msg.timestamp.lastIndexOf("."))
                    // 
                })
                if (parseInt(mwg_msg.events.bedState) !== 15 &&
                    parseInt(mwg_msg.events.bedState) !== 4 &&
                    parseInt(mwg_msg.events.bedState) !== 7 &&
                    parseInt(mwg_msg.events.bedState) !== 8 &&
                    parseInt(mwg_msg.events.bedState) !== 217 &&
                    parseInt(mwg_msg.events.bedState) !== 501 &&
                    parseInt(mwg_msg.events.bedState) !== 502 &&
                    parseInt(mwg_msg.events.bedState) !== 503 &&
                    parseInt(mwg_msg.events.bedState) !== 504 &&
                    parseInt(mwg_msg.events.bedState) !== 505 &&
                    parseInt(mwg_msg.events.bedState) !== 511 &&
                    parseInt(mwg_msg.events.bedState) !== 512

                ) {
                    setRR({
                        mac_left: mwg_msg.events.mattressMac,
                        value: "-"
                    });
                }
                if (parseInt(mwg_msg.events.bedState) === 206) {
                    // 斷線
                    setRssi({ bed_id: parseInt(mwg_msg.events.bedId), value: null });
                }
                break;
            case "mwg/Moteck": // 床 - 即時狀態(角度)
                mwg_msg = JSON.parse(mqttmessage.payloadString);
                setMoteck(mwg_msg)
                break;
            case "mwg/Moteck_auto_lock": // 床 - 即時狀態/只針對不同床的auto和lock
                mwg_msg = JSON.parse(mqttmessage.payloadString);
                // {"bed_id": "20", "auto": "0", "lock": "0"}
                let _bedState = {
                    bed_id: parseInt(mwg_msg.bed_id),
                    auto: parseInt(mwg_msg.auto),
                    all_lock: parseInt(mwg_msg.lock)
                }
                setMoteckAL(_bedState)
                break;
            case "alert_reply": // aidc moteck TR 問題
                mwg_msg = mqttmessage.payloadString
                // init serial failed!
                // 請壓床右側才能完成系統設定!
                setMoteckAlertReply(mwg_msg)
                setTimeout(() => {
                    setMoteckAlertReply(false)
                }, [3000])
                break;
            case "FSensor/Left": // 床 - 左半部即時動態
                mwg_msg = mqttmessage.payloadString
                setFsenLeft(mwg_msg)
                break;
            case "FSensor/Right": // 床 - 右半部即時動態
                mwg_msg = mqttmessage.payloadString
                setFsenRight(mwg_msg)
                break;
            case "FSensor/Down": // 床 - 下半部即時動態
                mwg_msg = mqttmessage.payloadString
                setFsenDown(mwg_msg)
                break;
            case "mwg/breath": // 床 - 給 前端呼吸值
                mwg_msg = String(mqttmessage.payloadString).replace(" ", "")
                setRR({
                    mac_left: mwg_msg.split(",")[0],
                    value: mwg_msg.split(",")[1]
                });
                break;
            case "mwg_mqtt_tr/CF_RR": // 床 - 心跳
                // payload = MacID , CF_CFHeartBeat , CF_Breathing
                mwg_msg = String(mqttmessage.payloadString).replace(" ", "")
                setCFHeartBeat({
                    mac_left: mwg_msg.split(",")[0],
                    value: parseInt(mwg_msg.split(",")[1])
                });
                setCFBreath({
                    mac_left: mwg_msg.split(",")[0],
                    value: parseInt(mwg_msg.split(",")[2])
                });
                break;
            case "export/daily_report/service_start": // 收到 8:00 啟動匯出報表功能的topic
                mwg_msg = mqttmessage.payloadString;
                if (mwg_msg === "export_server_start") {
                    setExportStart(true)
                } else if (mwg_msg === "export_server_stop") {
                    setExportStart(false)
                }
                break;

            case "qingsheng_diaper": // 尿布 - 給 前端尿布數值
                mwg_msg = JSON.parse(mqttmessage.payloadString);
                setDiaper(mwg_msg)
                break;
            case "diaper_resolved": // 尿布 - 給 前端尿布數值
                mwg_msg = mqttmessage.payloadString;
                setDiaper(mwg_msg)
                break;
            case "scientech/door": // 宣佑-門磁:
                // mwg_msg = String(mqttmessage.payloadString).split(" ")[1]
                [mac, value] = String(mqttmessage.payloadString).split(",")
                setDoor({ mac: mac, value: parseInt(value) })
                break
            case "scientech/vibration": // 宣佑-WC震動:
                // mwg_msg = String(mqttmessage.payloadString).split(" ")[1]
                [mac, value] = String(mqttmessage.payloadString).split(",")
                setVibration({ mac: mac, value: parseInt(value) })
                break

            case "scientech/humid": // 宣佑-溼度:
                // mwg_msg = String(mqttmessage.payloadString).split(" ")[1]
                [mac, value] = String(mqttmessage.payloadString).split(",")
                setHumid({ mac: mac, value: parseInt(value) })
                break
            case "scientech/temp": // 宣佑-溫度:
                // mwg_msg = String(mqttmessage.payloadString).split(" ")[1]
                [mac, value] = String(mqttmessage.payloadString).split(",")
                setTemperature({ mac: mac, value: parseInt(value) })
                break
            case "scientech/pir": // 宣佑-陽台:
                // mwg_msg = String(mqttmessage.payloadString).split(" ")[1]
                [mac, value] = String(mqttmessage.payloadString).split(",")
                if (value === "PIR Sensor Re-active!") {
                    setPir({ mac: mac, value: "0" })
                }
                setPir({ mac: mac, value: parseInt(value) })
                break
            case "scientech/pir_reactive": // 宣佑-陽台:
                // mwg_msg = String(mqttmessage.payloadString).split(" ")[1]
                setPir({ mac: mac, value: 0 })
                break
            case "scientech/medicalbutton": // 宣佑-陽台:
                // mwg_msg = String(mqttmessage.payloadString).split(" ")[1]
                setMedicalButton({ mac: mac, value: 1 })
                break
            case "epmed": // 尿布 - 給 前端尿布數值
                mwg_msg = JSON.parse(mqttmessage.payloadString);
                setEpDevice(mwg_msg)
                break;
            case "verify_client_connection":  // crontab丟給前端做確認
                let status = mqttmessage.payloadString.split(",")[2]
                if (status === "connection_check") {
                    setConnectionCheck(true)
                }
                break
            case "line_notify/get_bed_map":  // crontab丟給前端做確認
                let bed_map = JSON(mqttmessage.payloadString)
                setLine_notify_bed_map(bed_map)
                break
            case "upgrade_gv_system/adminStopService": // 當 msg == done，重新整理畫面
                mwg_msg = mqttmessage.payloadString;
                if (mwg_msg === "done") {
                    window.location.reload()
                }
                break;

            case "ap_rssi":
                mwg_msg = mqttmessage.payloadString;
                let rssi_bedId = mwg_msg.split(",")[1]
                    .split(":")          // 以冒號分割
                    .map(part => part.toUpperCase()) // 轉大寫
                    .join("");

                let rssi_value = parseInt(mwg_msg.split(",")[2]);
                setRssi({ bedId: rssi_bedId, value: rssi_value });

                break;

            case "volume":
            case "volume_min":
                mwg_msg = mqttmessage.payloadString;
                let volume_bedId = mwg_msg.split(",")[0]
                    .split(":")          // 以冒號分割
                    .map(part => part.toUpperCase()) // 轉大寫
                    .join("");

                let volume_value = parseInt(mwg_msg.split(",")[1]);
                setVolume({ bedId: volume_bedId, value: volume_value });
                break;
            default:
                break;
        }
    }

    // ✏*: called when disconnecting the client
    const _onDisconnect = () => {
        // 防止mqtt自己因為時間超過斷線而無法解除斷線
        try { client.disconnect(); }
        catch { }
    }

    // ✏*: called when subscribing topic(s)
    const _onUnsubscribe = () => {
        // 防止mqtt自己因為時間超過斷線而無法解除訂閱
        try {
            for (var i = 0; i < _topic.length; i++) { client.unsubscribe(_topic[i], _options); }
        }
        catch (e) { console.error("_onUnsubscribe: " + e); }
    }

    useEffect(() => {
        /* useEffect 1 */
        if (client === null) {
            _init();
        }
        return () => {
            if (sub) {
                _onUnsubscribe();
                _onDisconnect();
                setSub(false);
            }
        }
    }, [sub])

    useEffect(() => {
        /* useEffect 2 */
        if (client !== null) {
            try {
                client.connect({
                    // 連線成功後
                    // 參數加在此！！！
                    useSSL: (window.location.protocol === "http:") ? false : true,
                    userName: 'mwg',
                    password: 'mwgtdj168',
                    onSuccess: () => {
                        // 訂閱 topic
                        for (var i = 0; i < _topic.length; i++) {
                            client.subscribe(_topic[i], _options);
                        }
                        setSub(true);
                    }
                },
                    { willMessage: "last_will, close connection" }
                ); // ✏*: called when the client connects
            } catch (e) {
                console.error("Mos Unsuccessful: " + e);
            }
        }
    }, [client])

    try {
        return {
            // 測試組
            // test,
            // setTest, // ✅OK 已突破極限_但仍無法直接改 此元件內 test ⛝ERROR: 嘗試使用輸出setstate使用，結果失敗！
            // ---------〖TEST〗---------
            events, // 床 - 即時告警(角度): [bedId, alertLevel, bedState, timestamp]
            moteck, // 床 - 即時狀態(角度)
            moteckAL,
            // raw_dataLeft,
            // raw_dataDown,
            // raw_dataRight,
            moteckAlertReply,
            fsenLeft, // 床 - 左半部即時動態
            fsenRight, // 床 - 右半部即時動態
            fsenDown, // 床 - 下半部即時動態
            rr, // 床 - 給 前端呼吸值
            CFHeartBeat,
            CFBreath,
            diaper,

            exportStart, //是否啟動迴圈送報表功能
            door,
            vibration,
            humid,
            temperature,
            pir,
            medicalButton,
            epDevice,
            connectionCheck,
            startUpdateService,
            setConnectionCheck,
            sendPayload,
            line_notify_bed_map,
            rssi,
            volume,
        }
    } catch (e) {
        console.error("MOS Failure:" + e)
    }
}

export default Mos;